import { CurrencyCode, FundId, ToggleOption } from '@types';
import {
  IndexDailyHolding,
  IndexTopholding,
} from './model/index-top-constituent';
import { ColDef } from '@ag-grid-community/core';

// Type for Us Top Constituent

export interface USIndexTopConstituentsBRConfigTab {
  id: string;
  label: string;
  title: string;
}

export interface USIndexTopConstituentsBRConfig {
  fundId: FundId;
  fundName: string;
  ticker?: string;
  tabs?: USIndexTopConstituentsBRConfigTab[];
}

export interface USIndexTopConstituentsState {
  data: UsIndexConstituentData;
  config: USIndexTopConstituentsConfig;
  hasLoadedFullFeed?: boolean;
}

export interface UsIndexConstituentData {
  asOfDate?: string;
  tableData: any[];
  constituentDataByTimePeriod?: UsIndexTopConstituentsTimePeriodData;
  excelData?: IndexDailyHolding[];
}
export interface USIndexTopConstituentsConfig {
  currencyCode?: CurrencyCode;
  tableConfig?: USIndexTopConstituentsTimeSeriesTableData;
  topConstituentViews?: ToggleOption[];
  selectedTopConstituentView?: USIndexTopConstituentsView;
}

export interface USIndexTopConstituentsTimeSeriesTableData {
  title?: string;
  label?: string;
  tooltip?: string;
  proximalPlacementTop?: string;
  proximalPlacementBottom?: string;
  caveatPlacement?: string;
  updateFrequency?: string;
  asOfDate?: string;
  header?: ColDef[];
  body?: IndexTopholding[];
}

export enum USIndexTopConstituentsView {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export interface UsIndexTopConstituentsTimePeriodData {
  monthly: ConstituentTimePeriodData;
  quarterly: ConstituentTimePeriodData;
  daily: ConstituentTimePeriodData;
}

export interface ConstituentTimePeriodData {
  asOfDate?: string;
  data: IndexTopholding[];
}
